// src/dev/components/InspectorSection.tsx
// Collapsible section component for the inspector panel
import { useState, ReactNode } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

interface InspectorSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
  badge?: string | number;
  badgeColor?: "default" | "warning" | "error" | "success";
}

export function InspectorSection({
  title,
  defaultOpen = true,
  children,
  badge,
  badgeColor = "default",
}: InspectorSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const badgeColors = {
    default: "bg-slate-600 text-slate-200",
    warning: "bg-amber-600 text-amber-100",
    error: "bg-red-600 text-red-100",
    success: "bg-emerald-600 text-emerald-100",
  };

  return (
    <div className="border-b border-slate-700">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-slate-800/50 transition-colors"
      >
        {isOpen ? (
          <ChevronDown className="h-4 w-4 text-slate-400 flex-shrink-0" />
        ) : (
          <ChevronRight className="h-4 w-4 text-slate-400 flex-shrink-0" />
        )}
        <span className="text-sm font-medium text-slate-200">{title}</span>
        {badge !== undefined && (
          <span
            className={`ml-auto text-xs px-1.5 py-0.5 rounded ${badgeColors[badgeColor]}`}
          >
            {badge}
          </span>
        )}
      </button>
      {isOpen && (
        <div className="px-3 pb-3 text-sm text-slate-300">{children}</div>
      )}
    </div>
  );
}
